module.exports = __webpack_public_path__ + "static/media/carbon_footprint.925e0392.png";